(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('crossSiteMappingConfiguration', crossSiteMappingConfiguration);

	crossSiteMappingConfiguration.$inject = ['$rootScope', '$scope', '$state', '$timeout'];

	function crossSiteMappingConfiguration($rootScope, $scope, $state, $timeout) {
		var vm = this;
		var reportSettingsName = 'Cross-site mapping configuration';
		var meta = {};

		vm.getMeta = getMeta;

		$scope.type = 'customer';
		$scope.reportSettingsName = reportSettingsName;
		$scope.baseReportName = reportSettingsName;

		function getMeta() {
			return meta;
		}
	}
})();
